import React from 'react';

const Sidebar = props => {
  const { children, className, expanded, toggleNavigation } = props;
  return (
    <>
      <button
        className={
          expanded
            ? 'navbar-toggler sidebar-toggler sidebar-open'
            : 'navbar-toggler sidebar-toggler'
        }
        type="button"
        onClick={toggleNavigation}
      >
        <span className="navbar-toggler-icon" />
      </button>
      <div
        className={
          expanded
            ? `sidebar sidebar-open ${className || ''}`
            : `sidebar ${className || ''}`
        }
      >
        {children}
      </div>
    </>
  );
};

export default Sidebar;
